import { z } from 'zod';
import { CateringFormatModelSchema } from 'entities/catering-format';
import { GetCateringFormatBySlugApiResponseSchema } from '../store';

export const createCateringFormatFromGetCateringFormatBySlugApiResponse = (
    (response: z.infer< typeof GetCateringFormatBySlugApiResponseSchema>) => (
        CateringFormatModelSchema.parse({
            uid: response.data?.[0].slug,
            name: response.data?.[0].name,
            slug: response.data?.[0].slug,
            description: response.data?.[0].description,
            images: response.data?.[0].images?.map(({ url }) => ({
                url,
            })),
            menus: response.data?.[0].menus?.map(({
                name,
                description,
                warning,
                image,
                estimateFile,
            }) => ({
                name,
                description,
                warning,
                image: image && {
                    url: image.url,
                },
                estimateFile: estimateFile && {
                    url: estimateFile.url,
                },
            })),
        })
    )
);
